import { PasswordResetUser } from "@/types/passwordReset";
import {
  ConfirmationValidationProps,
  Validation,
  ValidationProps,
} from "@/types/validation";

const confirmation = (value: string, confirmValue: string) =>
  value === confirmValue;

const message = "Passwords do not match";

const digitSpecialCharValidation: ValidationProps = {
  message: "Must use least one digit or special character.",
  regex: /^((?=.*[0-9])|(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]))/gm,
};

const lengthValidation: ValidationProps = {
  message: "Must be fourteen (14) or more characters.",
  regex: /^.{14,}$/gm,
};

const lowerCharValidation: ValidationProps = {
  message: "Must use least one lower case character.",
  regex: /^(?=.*[a-z])/gm,
};

const spaceCharValidation: ValidationProps = {
  message: "Must not start or end with a space.",
  regex: /^(?!\s)(?![\s\S]*\s$)/gm,
};

const upperCharValidation: ValidationProps = {
  message: "Must use least one UPPER case character.",
  regex: /^(?=.*[A-Z])/gm,
};

export const passwordValidation: Validation<
  Pick<PasswordResetUser, "password" | "passwordConfirmation">
> = {
  password: [
    digitSpecialCharValidation,
    lengthValidation,
    lowerCharValidation,
    spaceCharValidation,
    upperCharValidation,
  ],
  passwordConfirmation: [
    {
      ...digitSpecialCharValidation,
      confirmation,
      message,
    } as ConfirmationValidationProps,
    {
      ...lengthValidation,
      confirmation,
      message,
    } as ConfirmationValidationProps,
    {
      ...lowerCharValidation,
      confirmation,
      message,
    } as ConfirmationValidationProps,
    {
      ...spaceCharValidation,
      confirmation,
      message,
    } as ConfirmationValidationProps,
    {
      ...upperCharValidation,
      confirmation,
      message,
    } as ConfirmationValidationProps,
  ],
};
